module.exports = __webpack_public_path__ + "static/media/business_qrcode.0463a99d.jpg";